export const columnDefs = [
  { field: 'select', dataType: 'select' },
  {
    field: 'resource',
    headerName: 'Resource',
    filterParams: { hideMenu: true },
    sortParams: { enabled: false },
  },
  {
    field: 'location',
    headerName: 'Location',
    filterParams: { hideMenu: true },
    sortParams: { enabled: true },
  },
  {
    field: 'workingDays',
    headerName: 'Working Days',
    filterParams: { hideMenu: true },
    sortParams: { enabled: true },
    cellRenderer: 'customRtoColumn',
  },
  {
    field: 'officeDays',
    headerName: 'Days in Office',
    filterParams: { hideMenu: true },
    sortParams: { enabled: true },
  },
  {
    field: 'remoteDays',
    headerName: 'Remote Days',
    filterParams: { hideMenu: true },
    sortParams: { enabled: true },
  },
  {
    field: 'rtoPercentage',
    headerName: 'RTO%',
    filterParams: { hideMenu: true },
    sortParams: { enabled: true },
  },
  {
    field: 'status',
    headerName: 'Status',
    filterParams: { hideMenu: true },
    sortParams: { enabled: false },
  },
];

export const exportColumnDefs = [
  ...columnDefs,
  { field: 'employmentType', headerName: 'Employment Type' },
  { field: 'reportingManager', headerName: 'Reporting Manager' },
  { field: 'l4Name', headerName: 'Manager' },
  { field : 'dntLeaderName', headerName: 'D&T Leader' },
  { field: 'comments', headerName: 'Comments' }
];

export const rtoLegendItems = [
  { id: 'regular', label: 'Regular', colorClass: 'regular' },
  { id: 'hybrid', label: 'Hybrid', colorClass: 'hybrid' },
  {
    id: 'partial-hybrid',
    label: 'Partial Hybrid',
    colorClass: 'partial-hybrid',
  },
  { id: 'remote', label: 'Remote', colorClass: 'remote' },
];
